import { VisitNoteTranscript } from '@seen/core/models/communications/VisitNoteTranscript'
import type { VisitNote } from '@seen/core/models/visitNote'
import { TypographySubtle } from '@seen/ui'
import type { JSX } from 'react'
import { Loader } from '#src/components/core/Loader.tsx'
import { SanitizedHTML } from '#src/components/core/SanitizedHTML.tsx'
import { useSearchOne } from '#src/hooks/useSearchOne.ts'

interface VisitNoteTranscriptViewProps {
  visitNote: VisitNote
}

export function VisitNoteTranscriptView({
  visitNote,
}: VisitNoteTranscriptViewProps): JSX.Element {
  const { data: transcript, isLoading } = useSearchOne(VisitNoteTranscript, {
    'based-on': visitNote.reference,
  })
  if (isLoading) {
    return <Loader />
  }
  if (!transcript?.message) {
    return (
      <TypographySubtle className="text-muted-foreground">
        No transcript found
      </TypographySubtle>
    )
  }

  return <SanitizedHTML htmlString={transcript.message} />
}
